import Api from '../Api'
import {
    HURTON_CATEGORIES_FETCH_FAILURE,
    HURTON_CATEGORIES_FETCH_SUCCESS,
    HURTON_CATEGORIES_FETCHING,
    PRODUCT_HURTON_CATEGORIES_FETCH_FAILURE,
    PRODUCT_HURTON_CATEGORIES_FETCH_SUCCESS,
    PRODUCT_HURTON_CATEGORIES_FETCHING,
} from './types'

export const getHurtonCategories = () => dispatch => {
    dispatch({
        type: HURTON_CATEGORIES_FETCHING,
    })

    Api.getHurtonCategories()
        .then(response => {
            dispatch({
                type: HURTON_CATEGORIES_FETCH_SUCCESS,
                payload: response.data,
            })
        })
        .catch(error => {
            dispatch({
                type: HURTON_CATEGORIES_FETCH_FAILURE,
                error,
            })
        })
}

/**
 * @param {number} id
 */
export const getProductHurtonCategories = id => dispatch => {
    dispatch({
        type: PRODUCT_HURTON_CATEGORIES_FETCHING,
    })

    Api.getProductHurtonCategories(id)
        .then(response => {
            dispatch({
                type: PRODUCT_HURTON_CATEGORIES_FETCH_SUCCESS,
                payload: response.data,
            })
        })
        .catch(error => {
            console.error(error)
            dispatch({
                type: PRODUCT_HURTON_CATEGORIES_FETCH_FAILURE,
            })
        })
}

/**
 * @param {number} categoryId
 * @param {number} productId
 */
export const addHurtonCategoryToProduct = (
    productId,
    categoryId
) => dispatch => {
    dispatch({
        type: PRODUCT_HURTON_CATEGORIES_FETCHING,
    })

    Api.addHurtonCategoryToProduct(categoryId, productId)
        .then(response => {
            dispatch({
                type: PRODUCT_HURTON_CATEGORIES_FETCH_SUCCESS,
                payload: response.data,
            })
        })
        .catch(error => {
            console.error(error)
            dispatch({
                type: PRODUCT_HURTON_CATEGORIES_FETCH_FAILURE,
            })
        })
}

/**
 * @param {number} categoryId
 * @param {number} productId
 */
export const removeHurtonCategoryFromProduct = (
    productId,
    categoryId
) => dispatch => {
    dispatch({
        type: PRODUCT_HURTON_CATEGORIES_FETCHING,
    })

    Api.removeHurtonCategoryFromProduct(categoryId, productId)
        .then(response => {
            dispatch({
                type: PRODUCT_HURTON_CATEGORIES_FETCH_SUCCESS,
                payload: response.data,
            })
        })
        .catch(error => {
            console.error(error)
            dispatch({
                type: PRODUCT_HURTON_CATEGORIES_FETCH_FAILURE,
            })
        })
}
